import { NavigateByPathCommand } from '../commands/navigate-by-path.command.model';
import { OperationType } from '../operation-type.enum';
import { OperationWithCommand } from '../operation-with-command.model';
import { CreateLeadPayload } from '../payloads/create-lead.payload.model';

export class CreateLeadOperation extends OperationWithCommand {
    static operationTypeStatic = OperationType.CreateLead;
    operationType = OperationType.CreateLead;
    payload = new CreateLeadPayload();
    queueCommands = [
      new NavigateByPathCommand(),
    ];
}
